// extracted by mini-css-extract-plugin
module.exports = {"up-horizontal-product-big":"style_up-horizontal-product-big___BXt_","productScrollContainer":"style_productScrollContainer__XBWVI","productList":"style_productList__119KY"};